import { ArrowDown } from "lucide-react";
import { BackgroundVideoWatermark } from "./BackgroundVideoWatermark";

const HERO_VIDEO = "/hero-video.mp4";

export const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative w-full min-h-[100svh] overflow-hidden bg-black"
    >
      {/* Background video */}
      <video
        data-testid="hero-bg-video"
        className="absolute inset-0 w-full h-full object-cover"
        src={HERO_VIDEO}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        aria-hidden="true"
      />

      {/* Overlays */}
      <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/40 to-black/80" />
      <div aria-hidden="true" className="absolute inset-0 bg-black/15" />
      <BackgroundVideoWatermark hero />

      {/* Main content */}
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-10 min-h-[100svh] flex flex-col justify-end pb-28 md:pb-32 pt-32">
        <div className="max-w-5xl">
          <h1
            data-testid="hero-h1"
            className="font-display text-white leading-[0.92] text-[14vw] sm:text-[10vw] md:text-[8vw] lg:text-[7vw] reveal"
          >
            <span className="block font-extralight">Gregory Bado</span>
            <span className="block font-semibold text-[#C5A059]">
              InnerGlow Productions<span className="text-[#C5A059]">.</span>
            </span>
          </h1>

          <p className="mt-10 max-w-2xl font-sans text-white/85 text-base md:text-lg leading-relaxed font-light reveal">
            A boutique production company specializing in documentary films,
            news coverage and event videography. From research and location
            scouting to field production and final delivery — every stage
            handled in-house.
          </p>
          <p className="mt-4 max-w-2xl font-sans text-white/55 text-sm md:text-base leading-relaxed font-light reveal">
            More than 20 years on the field — fast-paced newsrooms, long-form
            documentary storytelling, and high-end conference coverage.
          </p>

          <div className="mt-12 flex flex-wrap items-center gap-4 reveal">
            <a
              href="#work"
              data-testid="hero-cta-services"
              className="inline-flex items-center gap-3 px-8 h-12 bg-[#C5A059] text-black font-sans uppercase text-[11px] tracking-[0.28em] hover:bg-white hover:text-black transition-colors font-medium"
            >
              View Work
              <span className="h-px w-6 bg-current" />
            </a>
            <a
              href="#contact"
              data-testid="hero-cta-contact"
              className="inline-flex items-center gap-3 px-8 h-12 border border-white/80 text-white font-sans uppercase text-[11px] tracking-[0.28em] hover:bg-white hover:text-black transition-colors font-light"
            >
              Get in Touch
            </a>
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-white/55">
        <span className="font-sans uppercase text-[10px] tracking-[0.32em] font-light">Scroll</span>
        <ArrowDown size={14} strokeWidth={1.2} className="animate-bounce" />
      </div>
    </section>
  );
};
